//initial siren actions mapping
export default {
    //app actions
    switchDashboard: "dashboard.switchDashboard",
    reloadDashboard: "dashboard.reloadDashboardAndWidgets",
    switchContainer: "dashboard.switchContainer",
    loadApplicationConfig: "application.loadApplicationConfig",
    getStoreByName: "application.getStoreByName",
    reboot: "application.reboot",
    //authentication actions
    redirectToLoginScreen: "authentication.redirectToLoginScreen",

    //global
    setGlobalProperty: "global.setGlobalProperty",
    unsetGlobalProperty: "global.unsetGlobalProperty",
    //entity
    //update: "entity.update",

    //widget actions
    refreshWidget: "widget.refreshWidget",
    submitWidget: "widget.submitWidget",
    updateWidget: "widget.updateWidget",
    reloadWidget: "widget.reloadWidget",
    sendWidget: "widget.sendWidget",
    updateEntity: "widget.updateWidgetEntity",
    update: "widgetContainer.update",
    updateEntities: "widgetContainer.updateEntities",
    filterEntities: "widgetContainer.filterEntities",

    //flow/step actions
    updateFlow: "widgetContainer.updateFlow",
    getAvailableSteps: "flow.loadFlow",
    //cancelFlow: "flow.cancelFlowFromSirenAction",
    requestFlow: "flow.requestFlow",
    resumeStep: "flow.resumeStep",
    updateStep: "flow.updateStepFromSirenAction",
    //processStep: "flowSingleStep.processStepFromSirenAction",
    processStep: "flowContainer.processStep",
    cancelFlow: "flowContainer.cancelFlow",
    completeFlow: "flowContainer.completeFlow",
    showPreviousStep: "flowSingleStep.triggerShowPreviousStep",
    saveStep: "flowSingleStep.saveStepFromSirenAction",
    redirectOnFlowCompleted: "flow.redirectOnFlowCompleted",
    //updateFlow: "flow.updateFlowSirenAction",
    //utils
    uploadFiles: "component.uploadFiles",
    // changeLanguage => loadTranslations, changeLocale, reloadDashboardAndWidgets
    changeLanguage: "locale.changeLanguageFromSirenAction", //Note: kept for backwards compatibility only.
    // changeLocale => only change locale
    changeLocale: "locale.changeLocaleFromSirenAction",
    // dynamically loadTranslations from backend for currently set webui locale
    loadTranslations: "locale.loadTranslationsSiren",
    changeStaticTranslationLanguage: "locale.changeStaticTranslationLanguageSiren",

    confirmAction: "messages.openConfirmMessageFromSirenAction",
    confirm: "messages.confirmMessageFromSirenAction",
    openDocument: "application.openNewTab",
    openTarget: "application.openNewTab",
    //TODO: deprecate
    openTargetRoot: "application.openNewTabRoot",
    redirect: "application.redirect",
    refreshTable: "table.triggerRefreshTable",
    setTheme: "themes.setThemeFromSirenAction",
    updateComponentValue: "component.updateComponentValue",
    updateComponent: "component.updateComponent",
    updateComponentUiState: "component.updateComponentUiState",
    //TODO to be deprecated - replaced by update action
    //requestAction: "component.requestAction",
    loadMore: "component.loadMore",
    //scrolling
    scrollTo: "scroll.scrollToSirenAction",
    scrollPageTo: "scroll.scrollPageToSirenAction",
    scrollElementTo: "scroll.scrollElementToSirenAction",
    scrollPageToBottom: "scroll.scrollToBottom",
    //print
    printArea: "print.printAreaSirenAction",
    //geolocations
    setMapFocusFromLocationList: "geolocations.setMapFocusFromLocationListSirenAction",
    setListSelectionFromGeoLocationMap:
        "geolocations.setListSelectionFromGeoLocationMapSirenAction",
    //loading
    showLoading: "loading.showLoadingSirenAction",
    hideLoading: "loading.hideLoadingSirenAction",
    wait: "loading.wait",
    triggerLoading: "loading.triggerLoadingSiren",
    dismissLoading: "loading.dismissLoadingSiren",
    //modal
    openModal: "modal.openModalFromSirenAction",
    closeModal: "modal.closeModalFromSirenAction",
    compareCachedModalData: "modal.compareCachedModalData",
    //validations
    validate: "validations.validateData",

    copyToClipboard: "clipboard.copyToClipboard",
    addNotification: "messages.addNotification"
};
